import {AdviserRiskRow, ClientRiskRow, RiskSummary} from "./risk-model/RiskSummary";
import {isOverCbplLimit, isOverMarginLimit, isOverStelLimit, requiresMarginLimit} from "../util/RiskRowUtil";

export class RiskDashboardNotifications {

    private constructor(public readonly marginBreach: Array<ClientRiskRow> = [],
                        public readonly clientStelBreach: Array<ClientRiskRow> = [],
                        public readonly noMargin: Array<ClientRiskRow> = [],
                        public readonly cbplBreach: Array<ClientRiskRow> = [],
                        public readonly stelBreach: Array<AdviserRiskRow> = []) {
    }

    public get marginBreachCount(): number {
        return this.marginBreach.length;
    }

    public get noMarginCount(): number {
        return this.noMargin.length;
    }

    public get cbplBreachCount(): number {
        return this.cbplBreach.length;
    }

    public get clientStelBreachCount(): number {
        return this.clientStelBreach.length;
    }

    public get stelBreachCount(): number {
        return this.stelBreach.length;
    }

    public static build(model: RiskSummary): RiskDashboardNotifications {
        const clients = model.clients;
        const marginBreach = clients.filter(isOverMarginLimit);

        const clientStelBreach = model.clients
                                      .filter(isOverStelLimit);

        const noMargin = clients.filter(requiresMarginLimit);

        const cbplBreach = clients.filter(isOverCbplLimit);

        const stelBreach = model.advisers
                                .filter(isOverStelLimit);

        return new RiskDashboardNotifications(marginBreach, clientStelBreach, noMargin, cbplBreach, stelBreach);
    }
}
